import { faFolder } from '@fortawesome/pro-light-svg-icons';
import { faFolder as faFolderSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentType } from '@kcftech/prometheus-client';
import { ActionMenuItem } from 'components/menu/ActionMenuItem';
import { FolderModal } from 'pages/Settings/FileLibrary/Folder/FolderModal';
import { tokens } from 'styles/tokens';

import type { FileActionsBase } from './base';

function RenameFolderMenuItem({ base }: { base: FileActionsBase }) {
    if (!base.canEditFileLibrary || base.fileType !== ContentType.Folder) {
        return null;
    }
    return (
        <ActionMenuItem
            title="Rename Folder"
            hoverIcon={<FontAwesomeIcon icon={faFolderSolid} />}
            icon={<FontAwesomeIcon icon={faFolder} color={tokens.text.secondary} />}
            onSelect={() => base.openAction('edit-folder')}
        />
    );
}

function RenameFolderModal({ base }: { base: FileActionsBase }) {
    return (
        <FolderModal
            mode="edit"
            folderToEdit={base.rowData}
            onSave={() => {
                base.onChange();
                base.closeAction();
            }}
            onCancel={base.closeAction}
        />
    );
}

export const RenameFolder = {
    MenuItem: RenameFolderMenuItem,
    Modal: RenameFolderModal,
};
